import React from "react";
import { RxDragHandleDots2 as ReorderHandle } from "react-icons/rx";

export const DataManSortableHandler: React.FC = () => {
  return (
    <>
      <ReorderHandle className="h-5 w-5 text-neutral-600" />
    </>
  );
};
